const indexItems = [
  { title: '娱乐圈塌房合集', count: '247条', tag: '热门', icon: 'ri-movie-line' },
  { title: '网红翻车现场', count: '183条', tag: '推荐', icon: 'ri-live-line' },
  { title: '社会事件追踪', count: '156条', tag: '首发', icon: 'ri-newspaper-line' },
  { title: '明星恋情实锤', count: '132条', tag: '热议', icon: 'ri-heart-line' },
  { title: '行业黑幕曝光', count: '108条', tag: '深度', icon: 'ri-spy-line' },
  { title: '直播带货维权', count: '97条', tag: '跟进', icon: 'ri-shopping-bag-line' },
  { title: '选秀内幕揭秘', count: '89条', tag: '独家', icon: 'ri-mic-line' },
  { title: '吃瓜科普指南', count: '64条', tag: '实用', icon: 'ri-book-open-line' },
];

export default function IndexSection() {
  return (
    <section id="index" className="py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-10">
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">专题索引</h2>
            <p className="text-sm text-foreground-500">按话题分类浏览，快速定位你关注的吃瓜方向</p>
          </div>
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
            {indexItems.map((item, i) => (
              <a
                key={i}
                href="#cards"
                className="bg-background-100 rounded-lg border border-background-300/40 hover:border-background-300/70 hover:bg-background-200/60 transition-all duration-200 p-5 text-center group cursor-pointer"
              >
                <div className="w-11 h-11 mx-auto mb-3 rounded-lg bg-primary-500/10 flex items-center justify-center group-hover:bg-primary-500/20 transition-colors">
                  <i className={`${item.icon} text-lg text-primary-400`}></i>
                </div>
                <h3 className="font-heading text-sm text-foreground-800 mb-1">{item.title}</h3>
                <div className="flex items-center justify-center gap-2">
                  <span className="text-xs text-foreground-400">{item.count}</span>
                  <span className="text-[10px] px-1.5 py-0.5 rounded-full bg-accent-500/15 text-accent-400">{item.tag}</span>
                </div>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}